<template>
  <wizard-base class="procedure" :title="$t('WIZARD.PROCEDURE.TITLE')">
    <property-address />
    <ProcedureItems :items="items" />
    <HomedayMaximumPriceModal
      v-if="hasHomedayMaximumPriceForDeal()"
      :is-visible="showHomedayMaximumPricePopup"
      :homeday-maximum-price="currentDeal.homedayMaximumPrice"
      :is-acknowledging="isAcknowledgingEntryPopup"
      @acknowledge="onEntryPopupAcknowledge"
    />
  </wizard-base>
</template>

<script>
// Components
import WizardBase from '@/layout/WizardBase.vue';
import ProcedureItems from '@/components/ProcedureItems.vue';
import PropertyAddress from '@/components/PropertyAddress.vue';
import HomedayMaximumPriceModal from '@/components/wizard/HomedayMaximumPriceModal.vue';
import homedayMaximumPricePopupMixin, {
  homedayMaximumPriceEntryPopupMixin,
} from '@/mixins/homedayMaximumPricePopup';
// Icons
import {
  locationQuality as locationIcon,
  propertyMagnifier as propertyIcon,
  propertyMarketing as marketingIcon,
  houseSold as soldIcon,
} from 'homeday-assets/L';

export default {
  name: 'ProcedureSlide',
  components: {
    WizardBase,
    ProcedureItems,
    PropertyAddress,
    HomedayMaximumPriceModal,
  },
  mixins: [homedayMaximumPricePopupMixin, homedayMaximumPriceEntryPopupMixin],
  data() {
    return {
      items: [
        {
          icon: locationIcon,
          label: this.$t('GENERAL.LOCATION'),
        },
        {
          icon: propertyIcon,
          label: this.$t('GENERAL.PROPERTY'),
        },
        {
          icon: marketingIcon,
          label: this.$t('GENERAL.MARKET_COMPARISON'),
        },
        {
          icon: soldIcon,
          label: this.$t('GENERAL.SELLING_STRATEGY'),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.procedure {
  &.slides__slide {
    padding-top: 0;
  }
}
</style>
